module.exports = __webpack_public_path__ + "static/media/upgrade-city-rsm.31359651.svg";